var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 136.89 105.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-size: 15.93px;\n        letter-spacing: .06em;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: #fa935b;\n      }\n\n      .cls-1, .cls-3 {\n        font-family: CascadiaCode, 'Cascadia Code';\n      }\n\n      .cls-4 {\n        fill: #2f4858;\n      }\n\n      .cls-5 {\n        fill: #112240;\n      }\n\n      .cls-3 {\n        font-size: 15.93px;\n        letter-spacing: .06em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "120.72 52.55 99.74 74.09 99.74 67.9 114.69 52.55 99.74 37.23 99.74 31.15 99.81 31.08 120.72 52.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "36.47 37.85 22.2 52.55 36.47 67.17 36.47 73.39 16.17 52.55 36.47 31.67 36.47 37.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "99.73 14.89 99.73 25.38 36.58 90.25 36.46 90.13 36.46 79.61 36.61 79.76 65.74 49.79 99.73 14.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "36.46 15.15 36.47 19.77 36.47 25.66 36.46 25.67 10.22 52.62 36.46 79.61 36.46 90.13 34.07 87.61 0 52.62 36.46 15.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "99.74 80.32 126.67 52.62 99.74 25.37 99.73 25.38 99.73 14.89 99.74 14.88 104.87 20.1 136.89 52.62 99.73 90.81 99.74 84.73 99.74 80.32"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(96.45 36.3) rotate(134.24) skewX(-1.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sreenath")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(41.53 69.86) rotate(-46.81) skewX(-1.52)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "sreenath"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e17ecc9a3f171168e402a10ef4e7b780.svg";
export { ForwardRef as ReactComponent };